import { useEffect, useState } from "react";
import { serverNow } from "../../lib/serverClock";

/** Re-render every second while a countdown is visible (server-adjusted clock; display only). */
export function useServerNow(active: boolean): number {
  const [now, setNow] = useState(serverNow);
  useEffect(() => {
    if (!active) return;
    setNow(serverNow());
    const t = setInterval(() => setNow(serverNow()), 1000);
    return () => clearInterval(t);
  }, [active]);
  return now;
}
